// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconPlasma } from "../../../icons/mono/build/icon-plasma.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const PlasmaIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconPlasma.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  PlasmaIcon.displayName = 'PlasmaIcon';
}

export default PlasmaIcon;